import communityWalkthrough from '../../modules/community/walkthrough/zu.json';

export const ZU = {
  translation: {
    ...communityWalkthrough,
  },
};
